import Sortable from "sortablejs/modular/sortable.core.esm.js"
import { reorderTqasMutation } from "../utils/reorder_tqas"

export default function triggersSortable(serviceSlug) {
  function reorderTriggers() {
    let triggerIds = []
    document.querySelectorAll(".input-list li").forEach(trigger => {
      triggerIds.push(trigger.dataset["triggerId"])
    })

    reorderTqasMutation(serviceSlug, "trigger", triggerIds)
      .then(() => {
        App.Scripts.partners.displayFlash("Triggers reordered")
      })
      .catch(() => {
        App.Scripts.partners.displayFlash("There has been an error reordering the Triggers, try again!", "error")
      })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderTriggers,
  })
}
